module.exports = __webpack_public_path__ + "static/media/commentFacebook.c3b38c92.svg";